/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_H1Inputs */

const en_about_h1 = /** @type {(inputs: About_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About PureJSON`)
};

const ko_about_h1 = /** @type {(inputs: About_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON 소개`)
};

const ja_about_h1 = /** @type {(inputs: About_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONについて`)
};

/**
* | output |
* | --- |
* | "About PureJSON" |
*
* @param {About_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_h1 = /** @type {((inputs?: About_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_h1(inputs)
	if (locale === "ko") return ko_about_h1(inputs)
	return ja_about_h1(inputs)
});